import { render, staticRenderFns } from "./LogisticPartner.vue?vue&type=template&id=580fc162&"
import script from "./LogisticPartner.vue?vue&type=script&lang=js&"
export * from "./LogisticPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports